var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownloadapp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H68C74.3513 0.5 79.5 5.64873 79.5 12V68C79.5 74.3513 74.3513 79.5 68 79.5H12C5.64873 79.5 0.5 74.3513 0.5 68V12C0.5 5.64873 5.64873 0.500001 12 0.5Z",
    fill: "url(#paint0_linear_18_2234)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H68C74.3513 0.5 79.5 5.64873 79.5 12V68C79.5 74.3513 74.3513 79.5 68 79.5H12C5.64873 79.5 0.5 74.3513 0.5 68V12C0.5 5.64873 5.64873 0.500001 12 0.5Z",
    stroke: "url(#paint1_linear_18_2234)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 23.5833C30.8002 23.5833 23.3335 31.0499 23.3335 40.2499C23.3335 49.4499 30.8002 56.9166 40.0002 56.9166C49.2002 56.9166 56.6668 49.4499 56.6668 40.2499C56.6668 31.0499 49.2002 23.5833 40.0002 23.5833ZM45.8835 41.9666L40.8835 46.9666C40.6335 47.2166 40.3168 47.3333 40.0002 47.3333C39.6835 47.3333 39.3668 47.2166 39.1168 46.9666L34.1168 41.9666C33.6335 41.4833 33.6335 40.6833 34.1168 40.1999C34.6002 39.7166 35.4002 39.7166 35.8835 40.1999L38.7502 43.0666V34.4166C38.7502 33.7333 39.3168 33.1666 40.0002 33.1666C40.6835 33.1666 41.2502 33.7333 41.2502 34.4166V43.0666L44.1168 40.1999C44.6002 39.7166 45.4002 39.7166 45.8835 40.1999C46.3668 40.6833 46.3668 41.4833 45.8835 41.9666Z",
    fill: "#34D399"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2234",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2234",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 69.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadapp);
export default __webpack_public_path__ + "static/media/icon-downloadapp.8cbb481c069aed46249cddbc92b3967a.svg";
export { ForwardRef as ReactComponent };